import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { getNumberOfDaysBreakPoint } from '../../../libs/calendarConfig';
import clsx from 'classnames';
import { statuses } from '../WorkDayStatuses';

const atLocationLookup = {};
statuses.forEach(({ value, isAtLocation, shortDisplay }) => {
	if (isAtLocation) {
		atLocationLookup[value] = shortDisplay;
	}
});

function styles() {
	return {
		flagContainer: {
			display: 'flex',
			flexDirection: 'column',
			position: 'absolute',
			top: 0,
			right: 0,
			bottom: 0,
			margin: 1,
			zIndex: 5,
			writingMode: 'vertical-rl',
			textOrientation: 'mixed',
			fontWeight: 700,
			textTransform: 'uppercase',
			textAlign: 'center',
		},
		flagNodIsSmall: {
			fontSize: 13,
			padding: `0px 2px`,
		},
		flagNodIsMedium: {
			fontSize: 11,
			padding: `0px 1px`,
		},
		flagNodIsLarge: {
			fontSize: 8,
			padding: `0px 0px`,
		},
		extraDayFlag: {
			height: '100%',
			backgroundColor: '#DCEDC8',
			color: '#558B2F',
		},
		extraDayFlagNodIsLarge: {
			fontSize: 12,
		},
		modifiedDayFlag: {
			height: '100%',
			backgroundColor: '#F3E2D2',
			color: '#DB6700',
		},
		modifiedDayFlagNodIsLarge: {
			fontSize: 12,
		},
		swapOnFlag: {
			fontSize: 10,
			height: '100%',
			backgroundColor: '#c8eced',
			color: '#2f828b',
		},
		swapOnFlagNodIsLarge: {
			fontSize: 10,
		},
		atLocationFlag: {
			fontSize: 10,
			height: '100%',
			backgroundColor: '#e1e2c8',
			color: '#515100',
			whiteSpace: 'noWrap',
		},
		atLocationFlagNodIsLarge: {
			whiteSpace: 'noWrap',
			fontSize: 11,
		},
		lateFlag: {
			fontSize: 11,
			height: '100%',
			backgroundColor: '#FBE9E7',
			color: '#D84315',
		},
		schedFlag: {
			fontSize: 11,
			height: '100%',
			backgroundColor: '#FFF9C4',
			color: '#333333',
		},
		issueFlag: {
			fontSize: 11,
			height: '100%',
			backgroundColor: '#FFECB3',
			color: '#BF360C',
		},
	};
}

class ShiftFlags extends PureComponent {
	render() {
		const { numberOfDays, classes, isLate, workDayStatus } = this.props;

		const { nodIsMedium, nodIsLarge } = getNumberOfDaysBreakPoint(numberOfDays);

		let flagClass = classes.flagNodIsSmall;
		if (nodIsLarge) {
			flagClass = classes.flagNodIsLarge;
		} else if (nodIsMedium) {
			flagClass = classes.flagNodIsMedium;
		}

		if (nodIsLarge && (workDayStatus === 'extraDay' || workDayStatus === 'modifiedDay')) {
			flagClass = classes.extraDayFlagNodIsLarge;
		}

		if (nodIsLarge && workDayStatus === 'swapOn') {
			flagClass = classes.swapOnFlagNodIsLarge;
		}

		const atLocationShortDisplay = atLocationLookup[workDayStatus];

		if (nodIsLarge && atLocationShortDisplay) {
			flagClass = classes.atLocationFlagNodIsLarge;
		}

		return (
			<div className={classes.flagContainer}>
				{workDayStatus === 'extraDay' && (
					<div className={clsx(classes.extraDayFlag, flagClass)}>ED</div>
				)}

				{workDayStatus === 'modifiedDay' && (
					<div className={clsx(classes.modifiedDayFlag, flagClass)}>MOD</div>
				)}

				{workDayStatus === 'swapOn' && (
					<div className={clsx(classes.swapOnFlag, flagClass)}>SWAP</div>
				)}

				{atLocationShortDisplay && (
					<div className={clsx(classes.atLocationFlag, flagClass)}>
						{nodIsLarge ? '' : '@ '}
						{atLocationShortDisplay}
					</div>
				)}

				{isLate && <div className={clsx(flagClass, classes.lateFlag)}>Late</div>}
			</div>
		);
	}
}
ShiftFlags.propTypes = {
	numberOfDays: PropTypes.number,
};
ShiftFlags.defaultProps = {};
export default withStyles(styles)(ShiftFlags);
